<section>
  <div class="row">
    <div class=" container-style col-lg-12 col-md-12 col-sm-12 col-12" [hidden]="!isFormView">
      <form novalidate [formGroup]="formQuotationVersion">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="quotationVersionContract.userNameCreate"
              [createDate]="quotationVersionContract.createDate"
              [userNameUpdate]="quotationVersionContract.userNameUpdate"
              [updateDate]="quotationVersionContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1 col-md-2 col-sm-2 col-6">
            <app-custom-input-number formControlName="quotationConsecutive" [labelText]="'Cotización'"
              [recovery]="true"></app-custom-input-number>
          </div>

          <div class="col-lg-1 col-md-2 col-sm-2 col-6">
            <app-custom-input-number formControlName="consecutive" [labelText]="'Versión'" [required]="true"
              [recovery]="true" (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
          </div>

          <div class="col-lg-2 col-md-2 col-sm-3 col-6">
            <app-custom-datepicker formControlName="dateVersion" [labelText]="'Fecha Versión'"
              [required]="true"></app-custom-datepicker>
          </div>

          <div class="col-lg-4 col-md-5 col-sm-5 col-12">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'"
              [rows]="1"></app-custom-textarea>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-3 col-6">
            <div class="field-container d-flex flex-column">
              <app-custom-tag [label]="'Estado'" [severity]="quotationVersionContract.active ? 'danger' : 'succeess'"
                [value]="quotationVersionContract.active ? 'Abierto' : 'Cerrado'"></app-custom-tag>
            </div>
          </div>
          <div class="col-lg-1 col-md-2 col-sm-3 col-6 d-flex align-items-end">
            <app-custom-button [icon]="quotationVersionContract.active ? 'pi pi-lock-open' : 'pi pi-lock'"
              [title]="quotationVersionContract.active ? 'Cerrar' : 'Abrir'" [severity]="'primary'"
              [disabled]="quotationVersionContract.quotationVersionId == 0"
              (onClick)="changeStateVersion()"></app-custom-button>
          </div>
          <div class="col-lg-2 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-2 gap-2">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disabledForm"
              [variant]="undefined" [width]="'5rem'" (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row container-style mt-1">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end mb-1">
      <app-custom-button class="widthBtns" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
        [severity]="'success'" [variant]="undefined" (onClick)="createNewQuotationVersion()"></app-custom-button>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="header" [data]="detailData" [actions]="tableActions"
        (onPageChange)="onPageChange($event)" (onRecoverData)="getAllQuotationVersionsWithPagination()"
        (onAction)="onAction($event)"></app-custom-table>
    </div>
  </div>
</section>